export default {"src":"/_next/static/media/negative.a9ffb33a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};